export function titleize(key) {
    return key
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[A-Z]/g, (str) => str.toLowerCase())
        .replace(/_/g, ' ')
        .replace(/\b./g, (str) => str.toUpperCase());
}
//# sourceMappingURL=titleize.js.map